import {defineTokens} from '@chakra-ui/react3'

export const easings = defineTokens.easings({
    'ease-in': {
        value: 'cubic-bezier(0.42, 0, 1, 1)'
    },
    'ease-out': {
        value: 'cubic-bezier(0, 0, 0.58, 1)'
    },
    'ease-in-out': {
        value: 'cubic-bezier(0.42, 0, 0.58, 1)'
    },
    'ease-in-smooth': {
        value: 'cubic-bezier(0.32, 0.72, 0, 1)'
    },
    // Deceleration-only: leaves at full speed and settles softly. Figma
    // "SPECS/ANIMATIONS" annotation cards, nodes 34407-35356 / 34407-35541.
    'ease-out-strong': {
        value: 'cubic-bezier(0, 0, 0, 1)'
    },
    // Slow start into a hard stop. Figma "Canvas Expand", node 34407-35541.
    'ease-in-out-strong': {
        value: 'cubic-bezier(0.5, 0, 0, 1)'
    }
})
